import { Col, Row } from '@advanza/grid'
import { Divider } from '@advanza/ui'
import { useChangeEntity } from 'hooks/entityHooks'
import { useAppSelector } from 'hooks/hooks'
import React from 'react'

const fields = () => {
    return {
        use_construction_date: {
            type: 'boolean',
            msg: 'Construction date',
        },
        use_status: {
            type: 'boolean',
            msg: 'Status',
        },
        use_object_type: {
            type: 'boolean',
            msg: 'Object type',
        },
        use_surface_area: {
            type: 'boolean',
            msg: 'Surface area',
        },
        use_usages: {
            type: 'boolean',
            msg: 'Usages',
        },
    }
}

const BagUse = ({ entityId }) => {
    const { countries = [] } = useAppSelector((state) => state.countries)
    const { renderInput } = useChangeEntity(
        {
            store: 'services',
            name: 'bag_uses',
            entityId,
        },
        fields(),
    )

    return countries.indexOf('NL') === -1 ? null : (
        <>
            <div style={{ textAlign: 'left' }}>Add Kadaster data (NL)</div>
            <Divider m />
            <Row middle="xs">
                <Col x>{renderInput('use_construction_date')}</Col>
                <Col x>{renderInput('use_status')}</Col>
                <Col x>{renderInput('use_object_type')}</Col>
                <Col x>{renderInput('use_surface_area')}</Col>
                <Col x>{renderInput('use_usages')}</Col>
            </Row>
        </>
    )
}

export default BagUse
